import Vue from 'vue'
import login from './login.vue'
import store from '../../store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../../assets/ncss/global.scss'

import menu from '../../components/multimenu.vue'
import cTable from '../../components/elcomTable.vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import dropTable from '../../components/droptable.vue'
import TabRoute from '../../router/TabRoute'
import RouterMethods from '../../router/RouteMethod'
import cfilter from '../../components/filter.vue'
import selectItem from '../../components/selectItem.vue'

Vue.use(TabRoute)
Vue.use(RouterMethods)
Vue.use(VXETable)
Vue.component('dropTable',dropTable)
// Vue.component('colorset',colorset)
Vue.component('c-filter',cfilter)
Vue.component('select-modal',selectItem)

Vue.prototype.$XModal = VXETable.modal

Vue.prototype.$BH = function(){
	return window.BH;
}
Vue.component('MultiMenu', menu)
Vue.component('cTable', cTable)
Vue.config.productionTip = false;

Vue.use(ElementUI);

const setGUID=require('../../store/router.js').setGUID;
new Vue({
	store,
	render: h => h(login)
}).$mount('#appslot');
setGUID();
